<template>
  <v-card>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-dialog v-model="dialogNewBailleur" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Bailleur</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="formBaillleur" v-model="valid" lazy-validation>
              <v-text-field v-model="abbr_bailleur" label="Abbréviation" prepend-icon="label" :rules="nameRules"
                required></v-text-field>

              <v-text-field v-model="ll_bailleur" label="Nom" prepend-icon="label" :rules="nameRules"
                required></v-text-field>

           
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded class="primary" text @click="closeDialog">Annuler</v-btn>
            <v-btn rounded class="primary" text @click="updateCreateBailleur">Sauvegarder</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn outlined small fab dark class="transparent" @click.stop="$router.go(-1)">
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Bailleurs
      <v-spacer></v-spacer>

      <v-btn outlined small fab dark class="transparent" @click.stop="$router.go(-1)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>

    <v-card-text>
      <template>
        <v-btn color="blue-grey" class="ma-2 white--text" rounded @click="dialogNewBailleur = !dialogNewBailleur">
          <v-icon left dark> mdi-plus-circle-outline </v-icon>
          Nouveau Bailleur
        </v-btn>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Sigle
                </th>
                <th class="text-left">
                  Nom
                </th>
                <!-- <th class="text-left">
                  Choix CP
                </th>
                <th class="text-left">
                  Choix CM
                </th> -->
                <th class="text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in Bailleurs" :key="index">
                <td>{{ item.abbr_bailleur }}</td>
                <td>{{ item.ll_bailleur }}</td>
              
                <td>
                  <v-btn outlined x-small fab dark class="warning mr-2" @click="openDialog(item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn outlined x-small fab dark class="danger mr-2" @click="deleteBailleur(item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <v-btn outlined x-small fab dark class="success" @click="detailsBailleur(item)">
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { VListGroup } from "vuetify/lib";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      dialogNewBailleur: false,
      valid: true,
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 2) || "Au moins deux caractères",
      ],
      abbr_bailleur: "",
      ll_bailleur: "",
      id_bailleur: null,
      dialogDeleteBailleur: false,
      dialogLoading: false,
 
    };
  },
  created() {
    this.getListeBailleurs();
    this.getProjets();
    this.GetActivites();
  },
  mounted() {
    //console.clear();
  },
  methods: {
    ...mapActions({
      getListeBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetActivites: "Activites/GetAll",
    }),

    updateCreateBailleur() {
      let self = this;
      console.log("début");
      if (this.$refs.formBaillleur.validate()) {
        var objecttotupdate = {
          abbr_bailleur: self.abbr_bailleur,
          ll_bailleur: self.ll_bailleur,
     
        };
        //update bailleur
        if (this.id_bailleur !== null) {
          this.dialogLoading = true;
          let bailleurRef = this.$firebase
            .firestore()
            .collection("bailleurs")
            .doc(this.id_bailleur);
          return bailleurRef
            .update(objecttotupdate)
            .then(function () {
              // console.log("Bailleur successfully updated!");
              self.udpdateProjetsDeBailleur(self.id_bailleur, objecttotupdate);
              self.udpdateActivitesDeBailleur(self.id_bailleur, objecttotupdate);
              
              self.dialogLoading = false;
              self.id_bailleur = null;

              self.closeDialog();
              console.log("fin");
              self.getListeBailleurs();
            })
            .catch(function (error) {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);

              self.closeDialog();
            });
        } else {
          let uuid = "0000000000000000aaabailleur-" + this.$uuid.v4();
          //create Bailleur
          this.dialogLoading = true;

          // Add a new document with a generated id.
          this.$firebase
            .firestore()
            .collection("bailleurs")
            .doc(uuid)
            .set(objecttotupdate)

            .then(function (docRef) {
              //console.log("New Document written with ID: ", docRef.id);
              self.dialogLoading = false;
              self.id_bailleur = null;
              self.closeDialog();
              console.log("fin");
              self.getListeBailleurs();
            })
            .catch(function (error) {
              console.error("Error adding document: ", error);
              self.closeDialog();
            });
        }
      }

      self.closeDialog();
    },
    udpdateProjetsDeBailleur(idBailleur, data) {
      console.log("udpdateProjetsDeBailleur");
      //getAllprojets first
      let self = this;
      this.$firebase
        .firestore()
        .collection("projets")
        .where("id_bailleur", "==", idBailleur)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, " => ", doc.data());
            ///

            const projet = self.$firebase
              .firestore()
              .collection("projets")
              .doc(doc.id);

            projet.update(data);

            ///
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },

    udpdateActivitesDeBailleur(idBailleur, data) {
      console.log("udpdateActivitesDeBailleur");




      //getAllActivites first
      let self = this;
      this.$firebase
        .firestore()
        .collection("activites")
        .where("bailleurs_id_bailleur", "==", idBailleur)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {


            const activite = self.$firebase
              .firestore()
              .collection("activites")
              .doc(doc.id);

            activite.update(data);

            ///
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    openDialog(bailleur) {
      this.dialogNewBailleur = true;
      this.abbr_bailleur = bailleur.abbr_bailleur;
      this.ll_bailleur = bailleur.ll_bailleur;
      this.id_bailleur = bailleur.id;
 
    },
    closeDialog() {
      this.dialogNewBailleur = false;
      this.dialogDeleteBailleur = false;
      this.$refs.formBaillleur.reset();
    },
    deleteBailleur(bailleur) {
      let self = this;
      //delete bailleur in collection bailleurs
      const index = this.Bailleurs.indexOf(bailleur);
      this.$confirm(
        "Voulez vous Effacer ce bailleur?, Cela entrainera l'effacement des projet liés "
      ).then((ok) => {
        if (ok) {
          //delete bailleur in collection bailleurs
          this.Bailleurs.splice(index, 1);
          this.$firebase
            .firestore()
            .collection("bailleurs")
            .doc(bailleur.id)
            .delete()
            .then(function () {
              console.log("Bailleur successfully deleted!");
              //const index = self.bailleurs.indexOf(id_bailleur)
            })
            .catch(function (error) {
              console.error("Error removing document: ", error);
            });

          //delete projects which has bailleur in collection projets
          //first get projects of Bailleur
          let projectsOfBailleur = [];
          this.$firebase
            .firestore()
            .collection("projets")
            .where("id_bailleur", "==", bailleur.id.toString())
            .get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                // doc.data() is never undefined for query doc snapshots
                // console.log(doc.id, " => ", doc.data());
                projectsOfBailleur.push({
                  ...doc.data(),
                  id: doc.id,
                });
                projectsOfBailleur.forEach((projet, index) => {
                  //console.log(`Current index: ${index}`);
                  //console.log(projet.id);
                  self.deleteProject(projet.id);
                });
              });
            })
            .catch(function (error) {
              console.log("Error getting documents: ", error);
            });
        }
      });
    },
    deleteProject(idProjet) {
      this.$firebase
        .firestore()
        .collection("projets")
        .doc(idProjet)
        .delete()
        .then(function () {
          //console.log("Document successfully deleted!");
          //const index = self.bailleurs.indexOf(id_bailleur)
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
        });
    },

    detailsBailleur(bailleur) {
      ////console.log(bailleur.id);
      this.$router.push({
        name: "organisation-bailleurs-id",
        params: { bailleur },
      });
    },
  },

  computed: {
    ...mapState({
      Bailleurs: (state) => state.Bailleurs.bailleurs,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
